// External Links Warning
document.addEventListener('DOMContentLoaded', () => {
  const handleExternalLinks = () => {
    const links = document.querySelectorAll('a');
    const excludedLinks = []; // You can populate this array with links you want to exclude from the external link handling

    const isThirdParty = (url) => {
      try {
        const linkHost = new URL(url).hostname;
        const currentHost = window.location.hostname;
        return linkHost && linkHost !== currentHost;
      } catch (e) {
        return false;
      }
    };

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || !isThirdParty(href) || excludedLinks.includes(href)) return;

      // Open in new tab
      link.setAttribute('target', '_blank');

      // Set aria-label
      const existingText = link.textContent.trim();
      const ariaLabel = `${existingText}, This link will open in a new tab`;
      link.setAttribute('aria-label', ariaLabel);

      // Update image alt text
      const img = link.querySelector('img, svg');
      if (img) {
        let altText = img.getAttribute('alt') || '';
        const updatedAlt = altText
          ? `${altText}, This link will open in a new tab`
          : 'This link will open in a new tab';
        img.setAttribute('alt', updatedAlt);
      }
    });
  };

  // Adding timeout to ensure the DOM is fully loaded
  setTimeout(() => {
    handleExternalLinks();
  }, 500); // Adjust the timeout duration as needed (500ms here)
});

 
// Email and phone number labels
document.addEventListener('DOMContentLoaded', () => {
  const handleContactLinks = () => {
    const links = document.querySelectorAll('a[href^="mailto:"], a[href^="tel:"]');
 
    links.forEach(link => {
      const href = link.getAttribute('href');
      const linkText = link.textContent.trim();
 
      if (href.startsWith('mailto:')) {
        link.setAttribute('aria-label', `Email Address: ${linkText}`);
      } else if (href.startsWith('tel:')) {
        link.setAttribute('aria-label', `Phone number: ${linkText}`);
      }
    });
  };
 
  handleContactLinks();
});

////remove aria-aria-labelledby
setTimeout(function() {
  document.querySelectorAll('.card__heading a, .card__heading.h3 a, card__heading h3').forEach(function(link) {
    link.removeAttribute('aria-labelledby');
  });
}, 5000);

setTimeout(function() {
  document.querySelectorAll('.thumbnail.global-media-settings.global-media-settings--no-shadow', '.yotpo-widget-clear').forEach(function(el) {
    el.removeAttribute('aria-describedby');
  });
}, 5000);

///add aria-hidden="true" on all br tags

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('br').forEach(function(br) {
    br.setAttribute('aria-hidden', 'true');
  });
});

//remove aria-labelledby
setTimeout(() => {
  document.querySelectorAll('.card__heading.h3 a.full-unstyled-link').forEach(el => {
    el.removeAttribute('aria-labelledby');
  });
}, 1000); // 1-second delay




